import { createReducer } from "@reduxjs/toolkit";
import type { RetrievalState } from "@redux/state/shared-types";
import type { ExternalProviderDashboardVM } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { retrieveExternalProviderDashboard, resetRetrieveExternalProviderDashboard } from "./retrieve-external-provider-dashboard";

export interface ExternalProviderDashboardRetrievalState extends RetrievalState<Nullable<ExternalProviderDashboardVM>> {
  error: Nullable<string>;
}

const initialState: ExternalProviderDashboardRetrievalState = {
  fetching: "idle",
  data: null,
  error: null,
};

export const retrieveExternalProviderDashboardReducer = createReducer<ExternalProviderDashboardRetrievalState>(initialState, builder => {
  builder
    .addCase(retrieveExternalProviderDashboard.fulfilled, (state, action) => {
      return {
        ...state,
        fetching: "success",
        data: action.payload,
        error: null,
      };
    })
    .addCase(retrieveExternalProviderDashboard.pending, state => {
      return {
        ...state,
        fetching: "pending",
        error: null,
      };
    })
    .addCase(retrieveExternalProviderDashboard.rejected, state => {
      return {
        ...state,
        fetching: "failed",
        error: "Impossible de charger les données. Vérifiez votre lien d'accès.",
      };
    });
  builder.addCase(resetRetrieveExternalProviderDashboard, () => {
    return initialState;
  });
});
